<p-confirmDialog key="districtholiday" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="districtholidayconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Holiday</button>
		<button class="btn btn-warning" style="margin-left: 5px" (click)="onRemove()">Remove Holiday</button>
		<button class="btn btn-success" style="margin-left: 5px" (click)="onImport()">Import List</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstHoliday"
		[loading]="HolidayLoading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedHolidays"
		dataKey="ID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--CalendarDate-->
				<th>
					<!-- <p-columnFilter type="text" field="CalendarDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--IsOpenDesc-->
				<th>
					<p-columnFilter field="IsOpenDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsOpenDesc
								[ngModel]="value"
								[options]="lstIsOpenDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SchoolCount-->
				<th>
					<!-- <p-columnFilter type="text" field="SchoolCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--InFutureDesc-->
				<th>
					<p-columnFilter field="InFutureDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterInFutureDesc
								[ngModel]="value"
								[options]="lstInFutureDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="CalendarDate">Date<p-sortIcon field="CalendarDate"></p-sortIcon></th>
				<th pSortableColumn="IsOpenDesc">Open or Closed<p-sortIcon field="IsOpenDesc"></p-sortIcon></th>
				<th pSortableColumn="SchoolCount"># of Schools<p-sortIcon field="SchoolCount"></p-sortIcon></th>
				<th pSortableColumn="InFutureDesc">In the Future<p-sortIcon field="InFutureDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Holiday>
			<tr [pSelectableRow]="Holiday">
				<td>
					<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="Holiday" [value]="Holiday"></p-tableCheckbox>
				</td>

				<td
					*ngFor="let col of cols"
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="Holiday.InFuture == true ? 'Black' : 'Red'"
				>
					{{ Holiday[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Holiday.InFuture == true ? 'Black' : 'Red'">
					{{ Holiday.AllActiveSchools == true ? "All Schools" : Holiday.SchoolCount }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Holiday.InFuture == true ? 'Black' : 'Red'">
					{{ Holiday.InFutureDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
